import { ENDPOINTS } from "@/constants/endpoints";
import { route } from "@/utils/route";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { api, getToken } from "../api";
import { getOrgIdFromToken, getUserIdFromToken } from "../utils";

export interface PipedreamConnectTokenResponse {
  data: {
    token: string;
    expires_at: string;
  };
}

export async function postPipedreamConnectUserToken() {
  const token = await getToken();
  const orgId = getOrgIdFromToken(token);
  const userId = getUserIdFromToken(token);
  return api.post<
    PipedreamConnectTokenResponse,
    AxiosResponse<PipedreamConnectTokenResponse>,
    {}
  >(
    route(ENDPOINTS.ORG.PIPEDREAM.CONNECT_USER_TOKEN, {
      organization_id: orgId,
      user_id: userId,
    }),
    {},
  );
}

export async function postPipedreamConnectOrgToken() {
  const token = await getToken();
  const orgId = getOrgIdFromToken(token);
  return api.post<
    PipedreamConnectTokenResponse,
    AxiosResponse<PipedreamConnectTokenResponse>,
    {}
  >(
    route(ENDPOINTS.ORG.PIPEDREAM.CONNECT_ORG_TOKEN, {
      organization_id: orgId,
    }),
    {},
  );
}

export function usePostPipedreamConnectUserToken(
  options?: UseMutationOptions<
    AxiosResponse<PipedreamConnectTokenResponse>,
    unknown,
    void
  >,
) {
  return useMutation({
    mutationKey: ["postPipedreamConnectToken"],
    mutationFn: postPipedreamConnectUserToken,
    ...options,
  });
}

export function usePostPipedreamConnectOrgToken(
  options?: UseMutationOptions<
    AxiosResponse<PipedreamConnectTokenResponse>,
    unknown,
    void
  >,
) {
  return useMutation({
    mutationKey: ["postPipedreamConnectOrgToken"],
    mutationFn: postPipedreamConnectOrgToken,
    ...options,
  });
}
